import React, { useState, useEffect } from 'react';
import { Typography, Paper, Card, CardContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Tab, Box, IconButton, Tooltip,
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Snackbar, Alert, TablePagination, TextField, InputAdornment, FormControl,
  InputLabel, Select, MenuItem, useTheme, useMediaQuery, Grid, Chip, Avatar,Popover,
  colors,Skeleton
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneIcon from '@mui/icons-material/Phone';
import PhoneDisabledIcon from '@mui/icons-material/PhoneDisabled';
import FilterListIcon from '@mui/icons-material/FilterList';
import CallMadeIcon from '@mui/icons-material/CallMade';
import PersonIcon from '@mui/icons-material/Person';
import PillComponent from '../customcomponents/CustomPillComponent';
import SearchInput from '../customcomponents/CustomSearchInput';
import SelectInput from '../customcomponents/CustomSelectInput';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import CallIcon from '@mui/icons-material/Call';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import CallMissedIcon from '@mui/icons-material/CallMissed';
import { useNavigate } from 'react-router-dom';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SingleDateRangeFilter from "../customcomponents/CustomFilterDateRangePicker";
import api from '../api';
import { Sort } from '@mui/icons-material';

// Tab Panel Component
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`call-tabpanel-${index}`}
      aria-labelledby={`call-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const convertDuration = (seconds) => {
  if (seconds < 60) return `${seconds} sec`;
  if (seconds < 3600) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds} min`;
  }
  const hours = Math.floor(seconds / 3600);
  const remainingMinutes = Math.floor((seconds % 3600) / 60);
  return `${hours}:${remainingMinutes < 10 ? '0' : ''}${remainingMinutes} hr`;
};


function mapAndCategorizeCalls(calls) {
  const received = [];
  const dialed = [];
  const missed = [];

  if (!Array.isArray(calls)) {
    return { received, dialed, missed };
  }

  console.log('jasheer',calls)
  const allCalls = calls
    .filter(call => call) // Remove any null/undefined calls
    .map(call => {
      // Determine call status based on call type and duration
      let callStatus = 'unknown';
      let rawDuration = call.TCLM_Call_Duration || '';

      // Normalize duration: some records may contain seconds or a HH:MM:SS string. Keep as string.
      // Also expose a numeric seconds value when possible.
      let durationSeconds = null;
      if (typeof rawDuration === 'string' && rawDuration.includes(':')) {
        // Parse HH:MM:SS
        const parts = rawDuration.split(':').map(p => parseInt(p, 10) || 0);
        if (parts.length === 3) {
          durationSeconds = parts[0] * 3600 + parts[1] * 60 + parts[2];
        }
      } else if (rawDuration !== null && rawDuration !== undefined && rawDuration !== '') {
        // If it's a number or numeric string, coerce
        const num = Number(rawDuration);
        if (!Number.isNaN(num)) durationSeconds = num;
      }

      if (call.TCLM_Call_Type === 3) {
        callStatus = 'missed';
      } else if (call.TCLM_Call_Type === 2) {
        // Outgoing/dialed — consider connected unless duration explicitly 0
        if (durationSeconds === 0) callStatus = 'not connected';
        else callStatus = 'connected';
      } else if (call.TCLM_Call_Type === 1) {
        // Incoming/received
        if (call.TCLM_Call_Type === 3) {
          callStatus = 'missed';
        } else if (durationSeconds === 0) {
          callStatus = 'not connected';
        } else if (durationSeconds !== null) {
          callStatus = 'connected';
        } else {
          callStatus = call.TCLM_Call_Status || 'unknown';
        }
      } else {
        // Unknown type: use duration if possible
        if (durationSeconds === 0) callStatus = 'not connected';
        else if (durationSeconds !== null) callStatus = 'connected';
        else callStatus = call.TCLM_Call_Status || 'unknown';
      }
      return {
        id: call._id,
        patient: call.TCLM_Caller_Name || '',
        phone: call.TCLM_Caller_Number || '',
        service: call.TCLM_Device_ID || 'N/A',
        // duration: call.TCLM_Call_Type === 3 ? '00:00:00' : (call.TCLM_Call_Duration ? `${call.TCLM_Call_Duration}` : 'N/A'),
        duration: call.TCLM_Call_Type === 3 ,
        rawDuration: rawDuration,
        durationSeconds: durationSeconds,
        date: call.TCLM_Call_TimeStamp ? new Date(call.TCLM_Call_TimeStamp).toLocaleString() : 'N/A',
        type: call.TCLM_Call_Type || '1',
        status: callStatus,
        receiverNumber: call.TCLM_Receiver_Number || 'N/A',
        synced: call.TCLM_Synced === '1' ? 'Yes' : 'No',
        // Add raw date for sorting
        rawDate: call.TCLM_Call_Date ? new Date(call.TCLM_Call_Date) : new Date(0)
      };
    });

  // Categorize the sorted calls
  for (const call of allCalls) {
    if (call.type === 1) {
      received.push(call);
    } else if (call.type === 2) {
      dialed.push(call);
    } else if (call.type === 3) {
      missed.push(call);
    } else {
      // Default to received for unknown types
      received.push(call);
    }
  }

  return { received, dialed, missed };
}






// Function to group calls by person (phone number)
function groupCallsByPerson(receivedCalls, dialedCalls, missedCalls) {
  const personMap = new Map();



  // Process all calls and group by phone number
  const allCalls = [...receivedCalls, ...dialedCalls, ...missedCalls];
  
  allCalls.forEach(call => {
    const phone = call.phone;
    if (!personMap.has(phone)) {
      personMap.set(phone, {
        phone: phone,
        patient: call.patient,
        receivedCalls: [],
        dialedCalls: [],
        missedCalls: [],
        totalCalls: 0,
        lastCallDate: call.rawDate,
        service: call.service
      });
    }

    const person = personMap.get(phone);
    
    // Add call to appropriate category
    if (call.type === 1) {
      person.receivedCalls.push(call);
    } else if (call.type === 2) {
      person.dialedCalls.push(call);
    } else if (call.type === 3) {
      person.missedCalls.push(call);
    }

    // Update totals
    person.totalCalls = person.receivedCalls.length + person.dialedCalls.length + person.missedCalls.length;
    
    // Update last call date
    if (call.rawDate > person.lastCallDate) {
      person.lastCallDate = call.rawDate;
    }
  });

  // Convert map to array and sort by last call date (newest first)
  return Array.from(personMap.values()).sort((a, b) => b.lastCallDate - a.lastCallDate);
}

function CallLogsPageCopy() {
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);
  const [showWhatsAppDialog, setShowWhatsAppDialog] = useState(false);
  const [selectedCall, setSelectedCall] = useState(null);
  const [receivedCalls, setReceivedCalls] = useState([]);
  const [dialedCalls, setDialedCalls] = useState([]);
  const [missedCalls, setMissedCalls] = useState([]);
  const [personCallHistory, setPersonCallHistory] = useState([]);
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [showPersonModal, setShowPersonModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  // Pagination and search state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchAnchorEl, setSearchAnchorEl] = useState(null);
  const openPopover = Boolean(searchAnchorEl);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const openFilterPopover = Boolean(filterAnchorEl);

  // For status filter
  const [statusFilter, setStatusFilter] = useState('group');

  const theme = useTheme();
  const isSmallScreen = useMediaQuery('(max-width:800px)');

  // State for person modal call filtering
  const [filteredCallType, setFilteredCallType] = useState('all'); // 'all', 'received', 'dialed', 'missed'


  // For date range filter 
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);


  const handleDateRangeChange = (from, to) => {
    setFromDate(from);
    setToDate(to);
    setPage(0);
  };

  const handleSearchClick = (event) => {
    setSearchAnchorEl(event.currentTarget);
  };

  // Handle search
  const handleSearch = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
    setPage(0); // Reset to first page on new search
  };

  // Handle status filter change
  const handleStatusFilterChange = (event) => {
    setStatusFilter(event.target.value);
    setPage(0); // Reset to first page on filter change
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  // Handle clear filters
  const handleClearFilters = () => {
    setSearchTerm('');
    // Reset to grouped view by default
    setStatusFilter('group');
    setPage(0); // Reset to first page when clearing filters
  };

  // Filter person call history based on search term, date range and statusFilter
  const filterPersonCallHistory = (persons) => {
    if (!Array.isArray(persons)) return [];
    let filtered = persons.slice();

    // Search filter (on person level)
    if (searchTerm) {
      const q = searchTerm.toLowerCase();
      filtered = filtered.filter(person =>
        (person.patient && person.patient.toLowerCase().includes(q)) ||
        (person.phone && person.phone.includes(q)) ||
        (person.service && person.service.toLowerCase().includes(q))
      );
    }

    // Date range filter: keep person if any of their calls fall inside the range
    if (fromDate && toDate) {
      // Use the person's lastCallDate to decide inclusion in grouped view.
      // Compare dates inclusive of both endpoints. Normalize to date-only (midnight) to match "selected date" semantics.
      const from = new Date(fromDate);
      from.setHours(0,0,0,0);
      const to = new Date(toDate);
      to.setHours(23,59,59,999);

      filtered = filtered.filter(person => {
        if (!person.lastCallDate) return false;
        const last = new Date(person.lastCallDate);
        return last >= from && last <= to;
      });
    }

    // Status filter: when in grouped mode (statusFilter !== 'all'), keep only persons who have at least one call matching the status
    if (statusFilter && String(statusFilter).toLowerCase() !== 'group' && String(statusFilter).toLowerCase() !== 'all') {
      const sf = String(statusFilter).toLowerCase(); // e.g. 'connected', 'not connected', 'received', 'dialed', 'missed'
      filtered = filtered.filter(person => {
        const allCalls = [...person.receivedCalls, ...person.dialedCalls, ...person.missedCalls];
        return allCalls.some(c => {
          if (sf === 'connected') return String(c.status).toLowerCase() === 'connected';
          if (sf === 'not connected') return String(c.status).toLowerCase() === 'not connected';
          if (sf === 'received') return c.type === 1 || String(c.status).toLowerCase() === 'received';
          if (sf === 'dialed') return c.type === 2 || String(c.status).toLowerCase() === 'dialed';
          if (sf === 'missed') return c.type === 3 || String(c.status).toLowerCase() === 'missed';
          return false;
        });
      });
    }

    // Sort by last call date (newest first)
    filtered.sort((a, b) => b.lastCallDate - a.lastCallDate);

    return filtered;
  };

  // Flatten all calls into a single list for the 'All' view and apply filters
  const getAllCalls = () => {
    const all = [...receivedCalls, ...dialedCalls, ...missedCalls];
    // sort newest first
    return all.sort((a, b) => b.rawDate - a.rawDate);
  };

  const filterAllCalls = (calls) => {
    if (!Array.isArray(calls)) return [];
    let filtered = calls.slice();

    // Search filter (on call fields: patient, phone, service)
    if (searchTerm) {
      const q = searchTerm.toLowerCase();
      filtered = filtered.filter(c =>
        (c.patient && c.patient.toLowerCase().includes(q)) ||
        (c.phone && c.phone.includes(q)) ||
        (c.service && c.service.toLowerCase().includes(q))
      );
    }

    // Date range filter: use inclusive date bounds (normalize to day)
    if (fromDate && toDate) {
      const from = new Date(fromDate);
      from.setHours(0,0,0,0);
      const to = new Date(toDate);
      to.setHours(23,59,59,999);
      filtered = filtered.filter(c => c.rawDate && new Date(c.rawDate) >= from && new Date(c.rawDate) <= to);
    }

    // Status filter when in 'all' mode (if statusFilter is not 'all', apply it)
    if (statusFilter && String(statusFilter).toLowerCase() !== 'all' && String(statusFilter).toLowerCase() !== 'group') {
      const sf = String(statusFilter).toLowerCase();
      filtered = filtered.filter(c => {
        if (sf === 'connected') return String(c.status).toLowerCase() === 'connected';
        if (sf === 'not connected' ) return c.type === 3|| String(c.status).toLowerCase() === 'not connected';
        if (sf === 'received') return c.type === 1 || String(c.status).toLowerCase() === 'received';
        if (sf === 'dialed') return c.type === 2 || String(c.status).toLowerCase() === 'dialed';
        if (sf === 'missed') return c.type === 3 || String(c.status).toLowerCase() === 'missed';
        return true;
      });
    }
    //  nale ivde change veruthanam so that i can get the not connected calls at top



    // already sorted by rawDate earlier in getAllCalls, but ensure sorting
    filtered.sort((a, b) => b.rawDate - a.rawDate);
    return filtered;
  };


  


  // Helper to get paginated and filtered data
  const getPaginatedRows = (rows) => {
    const filteredRows = filterPersonCallHistory(rows);
    return filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);  
  };

  // Get total count after filtering
  const getFilteredCount = (rows) => filterPersonCallHistory(rows).length;

  // Get filtered calls for person modal based on selected call type
  const getFilteredCallsForPerson = () => {
    if (!selectedPerson) return [];
    
    switch (filteredCallType) {
      case 'received':
        return selectedPerson.receivedCalls;
      case 'dialed':
        return selectedPerson.dialedCalls;
      case 'missed':
        return selectedPerson.missedCalls;
      case 'all':
      default:
        return [
          ...selectedPerson.receivedCalls,
          ...selectedPerson.dialedCalls,
          ...selectedPerson.missedCalls
        ].sort((a, b) => b.rawDate - a.rawDate);
    }
  };

  useEffect(() => {
    const fetchCalls = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await api.get('/calls/logs');
        console.log('API Response:', res);

        let callsData = [];
        if (res.data && Array.isArray(res.data)) {
          callsData = res.data;
        } else if (res.data && res.data.data && Array.isArray(res.data.data)) {
          // Fallback for different response format
          callsData = res.data.data;
        } else {
          console.warn('Unexpected API response format:', res);
        }

        const { received, dialed, missed } = mapAndCategorizeCalls(callsData);
        setReceivedCalls(received);
        setDialedCalls(dialed);
        setMissedCalls(missed);
        
        // Group calls by person
        const personHistory = groupCallsByPerson(received, dialed, missed);
        setPersonCallHistory(personHistory);
      } catch (err) {
        setError('Failed to fetch calls');
        setReceivedCalls([]);
        setDialedCalls([]);
        setMissedCalls([]);
        setPersonCallHistory([]);
      } finally {
        setLoading(false);
      }
    };
    fetchCalls();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePersonClick = (person) => {
    setSelectedPerson(person);
    setFilteredCallType('all'); 
    setShowPersonModal(true);
  };

  const handleClosePersonModal = () => {
    setShowPersonModal(false);
    setSelectedPerson(null);
    setFilteredCallType('all'); 
  };
  const handleClose=()=>{
    setSearchAnchorEl(null);
    // setSearchTerm('');
  }

  const handleShowTicket = (row) => {
    navigate(`/ticket/${encodeURIComponent(row.phone)}`);
  };

  const handleWhatsAppClick = (call) => {
    setSelectedCall(call);
    setShowWhatsAppDialog(true);
  };

  const handleSendWhatsApp = async () => {
    if (!selectedCall) return;
    try {
      // Trim country code and non-digit prefix, keep last 10 digits
      let rawPhone = selectedCall.phone || '';
      rawPhone = rawPhone.replace(/\D/g, '');
      const trimmedPhone = rawPhone.slice(-10);
      const payload = {
        TA_Patient_Name: selectedCall.patient,
        TA_Patient_Mobile_Number: trimmedPhone,
        TA_Patient_Email_Address: '',
        TA_Patient_Age: 0,
        TA_Source_Type: 1
      };
      const res = await api.post('/patients', payload);
      if (res.data && res.data.success) {
        setSnackbar({ open: true, message: 'Whatsapp message sent', severity: 'success' });

        // Delay navigation by 2 seconds (2000 ms)
        setTimeout(() => {
          navigate('/interactions-new');
        }, 1500);
      } else {
        setSnackbar({ open: true, message: 'Failed to create patient', severity: 'error' });
      }
    } catch (err) {
      setSnackbar({ open: true, message: 'Failed to create patient', severity: 'error' });
    } finally {
      setShowWhatsAppDialog(false);
      setSelectedCall(null);
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbar({ ...snackbar, open: false });
  };

  const handleCancelWhatsApp = () => {
    setShowWhatsAppDialog(false);
    setSelectedCall(null);
  };

  // Handle call type filter change in person modal
  const handleCallTypeFilter = (type) => {
    setFilteredCallType(type);
  };

  // Helper to compute connected and not-connected counts for a person
  const connectedCountsForPerson = (person) => {
    // A call is considered not connected if: type === 3 (missed) OR durationSeconds === 0
    const all = [
      ...person.receivedCalls,
      ...person.dialedCalls,
      ...person.missedCalls,
    ];

    let notConnected = 0;
    let connected = 0;

    all.forEach(c => {
      try {
        // Prefer explicit type === 3
        if (c.type === 3) {
          notConnected += 1;
        } else if (c.durationSeconds === 0) {
          notConnected += 1;
        } else if (c.durationSeconds !== null && c.durationSeconds !== undefined) {
          connected += 1;
        } else {
          // If no duration info, infer: treat dialed (type 2) as connected
          if (c.type === 2) connected += 1;
          else notConnected += 1; // conservative
        }
      } catch (err) {
        notConnected += 1;
      }
    });

    return { connected, notConnected };
  };

  // Render call details table for the modal

  const renderCallDetailsTable = (calls) => {
    if (!calls || calls.length === 0) {
      return (
        <Typography variant="body2" sx={{ color: 'background.text', fontStyle: 'italic', mt: 1, textAlign: 'center', py: 3 }}>
          No calls found for the selected filter
        </Typography>
      );
    } 

   // Table for call details in the modal ie detailed table inside table

    return (
      <>
        {
          isSmallScreen ? (
            <Grid container spacing={2} marginTop={1}>
            {calls.map((call, index) => (
              <Grid item xs={12} key={call.id || index}>
                <Paper elevation={2} sx={{ borderRadius: 3, p: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Box sx={{mt:1}}>
                      <Typography variant="body2" sx={{ color: 'background.text' }}><span style={{ fontWeight: 700 }}>Date :</span> {call.date}</Typography>
                      <Typography variant="body2" sx={{ color: 'background.text' }}><span style={{ fontWeight: 700 }}>Type :</span> {call.type === 1 ? 'Received' : call.type === 2 ? 'Dialed' : 'Missed'}</Typography>
                      <Typography variant="body2" sx={{ color: 'background.text' }}><span style={{ fontWeight: 700 }}>Duration :</span> {convertDuration(call.rawDuration)}</Typography>
                      <Typography variant="body2" sx={{ color: 'background.text' }}><span style={{ fontWeight: 700 }}>Status :</span> {call.status}</Typography>
                      <Typography variant="body2" sx={{ color: 'background.text' }}><span style={{ fontWeight: 700 }}>Device ID :</span> {call.service}</Typography>
                    </Box>
                    <Typography variant="body2" sx={{ color: 'background.text' }}>#{page * rowsPerPage + index + 1}</Typography>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
          ):(
            <TableContainer sx={{ maxHeight: 260, overflowY: 'auto', mt: 1 }}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ bgcolor: 'primary.main' }}>
                    <TableCell sx={{ fontWeight: 600, color: 'white' }}>#</TableCell>
                    <TableCell sx={{ fontWeight: 600, color: 'white' }}>Date & Time</TableCell>
                    <TableCell sx={{ fontWeight: 600, color: 'white' }}>Type</TableCell>
                    <TableCell sx={{ fontWeight: 600, color: 'white' }}>Duration</TableCell>
                    <TableCell sx={{ fontWeight: 600, color: 'white' }}>Status</TableCell>
                    <TableCell sx={{ fontWeight: 600, color: 'white' }}>Device ID</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {calls.map((call,idx) => (
                    <TableRow key={call.id} hover>
                      <TableCell sx={{ color: 'background.text' }}>{idx + 1}</TableCell>
                      <TableCell sx={{ color: 'background.text' }}>{call.date}</TableCell>
                      <TableCell sx={{ color: 'background.text' }}>
                        {call.type === 1 ? 'Received' : call.type === 2 ? 'Dialed' : 'Missed'}
                      </TableCell>
                      <TableCell sx={{ color: 'background.text' }}>{convertDuration(call.rawDuration)}</TableCell>
                      <TableCell>
                        <PillComponent status={call.status} />
                      </TableCell>
                      <TableCell sx={{ color: 'background.text' }}>{call.service}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
      </>
    );
  };

  // Render the main person call history table
  const renderPersonCallTable = () => {
    const filteredPersons = filterPersonCallHistory(personCallHistory);
    const paginatedPersons = getPaginatedRows(filteredPersons);

    const convertSecondsToMinutes = (seconds) => {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds} min`;
    };

    // prepare flat calls list for 'all' view
    const allCalls = getAllCalls();
    const filteredCalls = filterAllCalls(allCalls);
    const paginatedCalls = filteredCalls.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((call)=>{
      return {
        ...call,
        duration: convertSecondsToMinutes(call.duration)
      }
    });
    


  // Normalize statusFilter for consistent checks
  const normalizedStatus = String(statusFilter || '').toLowerCase();
  // Treat specific filters as the flat 'All' view (show individual calls) so
  // Connected/Not Connected/Received/Dialed/Missed display the flat list
  const isAllView = normalizedStatus === 'all' || ['connected', 'not connected', 'received', 'dialed', 'missed'].includes(normalizedStatus);
    // Prepare desktop TableBody rows to avoid nested ternaries
    let bodyRows = [];
    if (isAllView) {
      if (filteredCalls.length === 0) {
        bodyRows.push(
          <TableRow key="no-calls">
            <TableCell colSpan={8} align="center" sx={{ py: 3 }}>
              <Typography variant="body1" color="background.text">No matching calls found</Typography>
            </TableCell>
          </TableRow>
        );
      } else {
        bodyRows = paginatedCalls.map((call,idx) => (
          <TableRow key={call.id || call._id} hover>
            <TableCell>{page * rowsPerPage + idx + 1}</TableCell>
            <TableCell sx={{ color: 'background.text',textAlign:'center'}}>{call.patient}</TableCell>
            <TableCell sx={{ color: 'background.text',textAlign:'center'  }}>{call.phone}</TableCell>
            <TableCell sx={{ color: 'background.text',textAlign:'center' }}>{call.service}</TableCell>
            <TableCell sx={{ color: 'background.text',textAlign:'center' }}><PillComponent status={call.type === 1 ? 'Received' : call.type === 2 ? 'Dialed' : 'Missed'} 
              sx={{backgroundColor: call.type === 1 ? '#d0f0c0' : call.type === 2 ? '#c0d8f0' : call.type === 3 ? '#f0c0c0' : '#f0f0f0', 
                  color: call.type === 1 ? '#2e7d32' : call.type === 2 ? '#1565c0' : call.type === 3 ? '#c62828' : '#b0b0b0',
                  borderColor: call.type === 1 ? '#2e7d32' : call.type === 2 ? '#1565c0' : call.type === 3 ? '#c62828' : '#b0b0b0',
                }} />
            </TableCell>
            <TableCell ><PillComponent status={call.status==='missed' || call.status==='not connected'?'Not Connected':'Connected'} /></TableCell>
            <TableCell sx={{ color: 'background.text',textAlign:'center' }}>{call.date}</TableCell>
            <TableCell sx={{ color: 'background.text',textAlign:'center' }}>{convertDuration(call.rawDuration)}</TableCell>
            <TableCell >
              <Tooltip title="Send WhatsApp">
                <IconButton size="small" onClick={() => handleWhatsAppClick(call)} sx={{ bgcolor: '#25D366', color: '#fff' }}>
                  <WhatsAppIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </TableCell>
          </TableRow>
        ));
      }
    } else {
      if (filteredPersons.length === 0) {
        bodyRows.push(
          <TableRow key="no-persons">
            <TableCell colSpan={9} align="center" sx={{ py: 3 }}>
              <Typography variant="body1" color="background.text">No matching persons found</Typography>
            </TableCell>
          </TableRow>
        );
      } else {
        bodyRows = paginatedPersons.map((person,idx) => (
          <TableRow key={person.phone} hover sx={{ cursor: 'pointer' }} onClick={() => handlePersonClick(person)}>
            <TableCell>{page * rowsPerPage + idx + 1}</TableCell> 
            <TableCell >
              <Box sx={{ display: 'flex', gap: 1,alignItems:'center' }}>
                <Avatar sx={{ bgcolor: 'primary.main', width: 32, height: 32  }}>
                  <PersonIcon fontSize="small"  />
                </Avatar>
                <Typography variant="subtitle2" fontWeight={600} sx={{ color: 'background.text' }}>{person.patient || 'Unknown'}</Typography>
              </Box>
            </TableCell>
            <TableCell sx={{ color: 'background.text', textAlign: 'center' }}>{person.phone}</TableCell>
            <TableCell sx={{ color: 'background.text', textAlign: 'center' }}>{person.service}</TableCell>
            <TableCell sx={{ color: 'background.text' }}>
              <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', alignItems: 'center' }}>
                <Tooltip title="Received Calls"><Chip label={person.receivedCalls.length} size="medium" color="success" variant="outlined" sx={{ backgroundColor: '#d0f0c0', color: '#2e7d32', borderColor: '#2e7d32' }} /></Tooltip>
                <Tooltip title="Dialed Calls"><Chip label={person.dialedCalls.length} size="medium" color="primary" variant="outlined" sx={{ backgroundColor: '#c0d8f0', color: '#1565c0', borderColor: '#1565c0' }} /></Tooltip>
                <Tooltip title="Missed Calls"><Chip label={person.missedCalls.length} size="medium" color="error" variant="outlined" sx={{ backgroundColor: '#f0c0c0', color: '#c62828', borderColor: '#c62828' }} /></Tooltip>
              </Box>
            </TableCell>
            <TableCell sx={{ color: 'secondary.main', fontWeight: 800, fontSize: 16 }}>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'center' }}>
                {(() => { const counts = connectedCountsForPerson(person); return (<><Tooltip title="Connected Calls"><Chip label={counts.connected} size="medium" variant="outlined" sx={{ backgroundColor: '#ffff', color: '#2e7d32', borderColor: '#2e7d32' }} /></Tooltip><Tooltip title="Not Connected Calls"><Chip label={counts.notConnected} size="medium" variant="outlined" sx={{ backgroundColor: '#ffff', color: '#bf360c', borderColor: '#bf360c' }} /></Tooltip></>); })()}
              </Box>
            </TableCell>
            <TableCell sx={{ color: 'warning.main', fontWeight: 800, fontSize: 16, textAlign: 'center' }}>{person.totalCalls}</TableCell>
            <TableCell sx={{ color: 'background.text', textAlign: 'center' }}>{person.lastCallDate.toLocaleDateString()}</TableCell>
            <TableCell sx={{ textAlign: 'center' }}>
              <Tooltip title="Send WhatsApp"><IconButton size="small" sx={{ bgcolor: '#25D366', color: '#fff', '&:hover': { bgcolor: '#1ebe57' } }} onClick={(e) => { e.stopPropagation(); handleWhatsAppClick({ phone: person.phone, patient: person.patient, service: person.service }); }}><WhatsAppIcon fontSize="small" /></IconButton></Tooltip>
            </TableCell>
            <TableCell sx={{ color: 'background.text', textAlign: 'center' }}>
              <Tooltip title="View Call Details"><IconButton aria-label="expand row" size="small" onClick={() => handlePersonClick(person)}><KeyboardArrowDownIcon /></IconButton></Tooltip>
            </TableCell>
          </TableRow>
        ));
      }
    }

    // Small screen rendering
    if (isSmallScreen) {
      if (isAllView) {
        return (
          <Grid container spacing={1}>
            {filteredCalls.map((call, index) => (
              <Grid item xs={12} key={call.id || index}>
                <Paper elevation={2} sx={{ borderRadius: 3, p: 2, display: 'flex', flexDirection: 'column', gap: 1,m:1,mt:0 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Box sx={{mt:1}}>
                      <Typography variant="body2" sx={{ color: 'background.text' }}><span style={{ fontWeight: 700 }}>Name :</span> {call.patient || 'Unknown'}</Typography>
                      <Typography variant="body2" sx={{ color: 'background.text' }}><span style={{ fontWeight: 700 }}>Mobile :</span> {call.phone}</Typography>
                      <Typography variant="body2" sx={{ color: 'background.text' }}><span style={{ fontWeight: 700 }}>Device ID :</span> {call.service}</Typography>
                      <Typography variant="body2" sx={{ color: 'background.text' }}><span style={{ fontWeight: 700 }}>Call Type :</span> {call.type === 1 ? 'Received' : call.type === 2 ? 'Dialed' : 'Missed'}</Typography>
                      <Typography variant="body2" sx={{ color: 'background.text' }}><span style={{ fontWeight: 700 }}>Call Status :</span> {call.status}</Typography>
                      <Typography variant="body2" sx={{ color: 'background.text' }}><span style={{ fontWeight: 700 }}>Date :</span> {call.date}</Typography>
                      <Typography variant="body2" sx={{ color: 'background.text' }}><span style={{ fontWeight: 700 }}>Duration :</span> {convertDuration(call.rawDuration)}</Typography>
                    </Box>
                    <Typography variant="body2" sx={{ color: 'background.text' }}>#{page * rowsPerPage + index + 1}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                    <IconButton size="small" sx={{ borderRadius: '50%',background: '#e9f9ef',color: '#25D366' }} onClick={(e) => { e.stopPropagation(); handleWhatsAppClick({ phone: call.phone, patient: call.patient, service: call.service }); }}>
                      <WhatsAppIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        );
      }

      return (
        <Grid container spacing={1}>
          {filteredPersons.map((person, index) => (
            <Grid item xs={12} key={person.phone}>
              <Paper
                elevation={2}
                sx={{ borderRadius: 3, p: 2, display: 'flex', flexDirection: 'column', gap: 1, cursor: 'pointer',
                  boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                  '&:hover': { boxShadow: '0 4px 20px rgba(0,0,0,0.1)', },
                  m:1,mt:0
                }}
                onClick={() => handlePersonClick(person)}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Avatar sx={{ bgcolor: 'primary.main', width: 40, height: 40 }}>
                      <PersonIcon />
                    </Avatar>
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600} sx={{ color: 'background.text', fontSize:12 }}>{person.patient || 'Unknown'}</Typography>
                      <Typography variant="body2" sx={{ color: 'background.text', fontSize:12 }}>{person.phone}</Typography>
                    </Box>
                  </Box>
                  <Typography variant="body2" sx={{ color: '#b0b0b0', fontWeight: 700,fontSize:12 }}>#{page * rowsPerPage + index + 1}</Typography>
                </Box>

                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                  <Chip label={`Received: ${person.receivedCalls.length}`} size="small" color="success" variant="outlined" sx={{ backgroundColor: '#d0f0c0', fontSize:12 }} />
                  <Chip label={`Dialed: ${person.dialedCalls.length}`} size="small" color="primary" variant="outlined" sx={{ backgroundColor: '#c0d8f0', fontSize:12 }} />
                  <Chip label={`Missed: ${person.missedCalls.length}`} size="small" color="error" variant="outlined" sx={{ backgroundColor: '#f0c0c0', fontSize:12 }} />
                  {(() => {
                    const counts = connectedCountsForPerson(person);
                    return (
                      <>
                        <Chip label={`Connected: ${counts.connected}`} size="small" color="success" variant="outlined" sx={{ backgroundColor: '#e6f4ea', color: '#2e7d32' }} />
                        <Chip label={`Not Connected: ${counts.notConnected}`} size="small" color="default" variant="outlined" sx={{ backgroundColor: '#fff4e6', color: '#bf360c' }} />
                      </>
                    );
                  })()}
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
                  <Typography variant="body2" sx={{ color: 'background.text', fontSize:12 }}>Total: {person.totalCalls} calls</Typography>
                  <Typography variant="body2" sx={{ color: 'background.text', fontSize:12 }}>Last: {person.lastCallDate.toLocaleDateString()}</Typography>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                  <Tooltip title="Send WhatsApp">
                    <IconButton size="small" sx={{ borderRadius: '50%',background: '#e9f9ef',color: '#25D366' }} onClick={(e) => { e.stopPropagation(); handleWhatsAppClick({ phone: person.phone, patient: person.patient, service: person.service }); }}>
                      <WhatsAppIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      );
    }

    // Desktop rendering
    return (
      <Paper elevation={1} sx={{ borderRadius: 3, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', p: 0, overflow: 'auto', background: 'background.paper',}}>
        <TableContainer sx={{ maxHeight: 540 }}>
          <Table stickyHeader>
            <TableHead>
              {isAllView ? (
                <TableRow sx={{ bgcolor: 'primary.main' }}>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>Sl No</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff',textAlign:'center' }}>Person</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff',textAlign:'center' }}>Phone</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff',textAlign:'center' }}>Device ID</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff',textAlign:'center' }}>Call Type</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff',textAlign:'center' }}>Call Status</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff',textAlign:'center' }}>Date & Time</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff',textAlign:'center' }}>Duration</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff',textAlign:'center' }}>Actions</TableCell>
                </TableRow>
              ) : (
                <TableRow sx={{ bgcolor: 'primary.main' }}>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>Sl No</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff',textAlign:'left' }}>Person</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff',textAlign:'center' }}>Phone Number</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff',textAlign:'center' }}>Device ID</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff',textAlign:'center' }}>Calls</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff',textAlign:'center' }}>Status</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff',textAlign:'center' }}>Total Calls</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff',textAlign:'center' }}>Last Call</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff',textAlign:'center' }}>Actions</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff',textAlign:'center' }}>Expand</TableCell>
                </TableRow>
              )}
            </TableHead>
            <TableBody>
              {bodyRows}
            </TableBody>
          </Table>
        </TableContainer>
        <Box sx={{ px: 2, py: 1, background: 'background.paper', borderRadius: '0 0 16px 16px' }}>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={isAllView ? filteredCalls.length : filteredPersons.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Rows per page:"
            labelDisplayedRows={({ from, to, count }) => `${from}–${to} of ${count}`}
            sx={{ border: 0, background: 'transparent', p: 0, color: 'background.text' }}
          />
        </Box>
      </Paper>
    );
  };

  return (
    <Box>
      {/* Header  */}
      <Paper elevation={0} sx={{
        p: { xs: 2, sm: 3 },
        mb: 2,
        borderRadius: 3,
        background: theme.palette.mode == 'dark' ? '#32373a' :  'white',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)', 
        display: 'flex',
        flexDirection: { xs: 'row', md: 'row' },
        alignItems: 'center',
        gap: 2,
        justifyContent: 'space-between',
        position: 'sticky',
        top: isSmallScreen?10:0,
        zIndex: 1000,
      }}
      >
        {isSmallScreen ? (
          <Typography variant="h5" sx={{ fontWeight: 700, flex: 1, textTransform: 'capitalize', color: 'background.text' }}>
            Calls
          </Typography>
        ) : (
          <Typography variant="h4" fontWeight={700} sx={{ color: 'background.text'}}>
            Call Logs
          </Typography>
        )}
        <Box sx={{display:'flex',flexDirection:{xs:'row',md:'row'},gap:2 ,alignItems:'center'}}>

          <SingleDateRangeFilter
            onDateRangeChange={handleDateRangeChange}
            showClearButton={true}
          />
          {isSmallScreen?(
            <>
              <IconButton
                  onClick={handleSearchClick}
                  color='primary'
                  // sx={{
                  //   bgcolor: theme.palette.primary.main,
                  //   color: theme.palette.primary.contrastText,
                  //   borderRadius: 2, boxShadow: 1,
                  //   '&:hover': { bgcolor: theme.palette.primary.dark, boxShadow: 2, },
                  //   height: 40, width: 40,
                  // }}
                >
                  <SearchIcon />
                </IconButton>
                <Popover open={openPopover} anchorEl={searchAnchorEl} onClose={handleClose}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
                  transformOrigin={{  vertical: 'top',  horizontal: 'left', }}
                  PaperProps={{ sx: { p: 1, boxShadow: 'none', backgroundColor: 'rgba(255, 255, 255, 0.2)', borderRadius: 2, width: '60vw',  maxWidth: 400, }, }}
                >
                  <SearchInput value={searchTerm} onChange={handleSearch} autoFocus />  
                </Popover> 

                <IconButton onClick={handleFilterClick} color="primary">
                  <FilterListIcon />
                </IconButton>

                <Popover
                  open={openFilterPopover}
                  anchorEl={filterAnchorEl}
                  onClose={handleFilterClose}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                  PaperProps={{ sx: { p: 1, background: theme.palette.background.paper, width: '40vw',  maxWidth: 400, }, }}
                >
                  <FormControl size="small" sx={{ width: '100%',
                  borderRadius: 1, }}>
                    <SelectInput
                      label="Filter"
                      value={statusFilter}
                      onChange={handleStatusFilterChange}
                      options={[
                        { label: "Group", value: "group" },
                        { label: "All", value: "all" },
                        { label: "Connected", value: "connected" },
                        { label: "Not Connected", value: "not connected" },
                        { label: "Received", value: "received" },
                        { label: "Dialed", value: "dialed" },
                        { label: "Missed", value: "missed" },
                      ]}
                    />
                  </FormControl>
                </Popover>
            </>
          ):(
            <>
              <SearchInput value={searchTerm} onChange={handleSearch} />
              <FormControl
                size="small"
                sx={{
                  minWidth: { xs: "100%", sm: 240 },
                  background: theme.palette.background.paper,
                  borderRadius: 1,
                }}
              >
                <SelectInput
                  label="Filter"
                  value={statusFilter}
                  onChange={handleStatusFilterChange}
                  options={[
                    { label: "Group", value: "group" },
                    { label: "All", value: "all" },
                    { label: "Connected", value: "connected" },
                    { label: "Not Connected", value: "not connected" },
                    { label: "Received", value: "received" },
                    { label: "Dialed", value: "dialed" },
                    { label: "Missed", value: "missed" },
                  ]}
                />
              </FormControl>
            </>
          )}
        </Box>        
      </Paper>
      {isSmallScreen ? (
        <Box sx={{ border:'1px solid transparent', backgroundColor:'transparent' }}>
        {loading ? (
          <Grid container spacing={1}>
            {Array.from(new Array(5)).map((_, index) => (
              <Grid item xs={12} key={index}>
                <Paper
                  elevation={2}
                  sx={{
                    borderRadius: 3,
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    m: 1,
                    mt: 0,
                    boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                  }}
                >
                  {/* Top row: Avatar + Name + Phone + Index */}
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Skeleton variant="circular" width={40} height={40} />
                      <Box>
                        <Skeleton variant="text" width={120} height={24} />
                        <Skeleton variant="text" width={80} height={18} />
                      </Box>
                    </Box>
                    <Skeleton variant="text" width={30} height={18} />
                  </Box>

                  {/* Chips row */}
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                    <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 16 }} />
                    <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 16 }} />
                    <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 16 }} />
                    <Skeleton variant="rectangular" width={100} height={24} sx={{ borderRadius: 16 }} />
                    <Skeleton variant="rectangular" width={120} height={24} sx={{ borderRadius: 16 }} />
                  </Box>

                  {/* Total calls & last call */}
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
                    <Skeleton variant="text" width={100} height={18} />
                    <Skeleton variant="text" width={80} height={18} />
                  </Box>

                  {/* WhatsApp icon */}
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                    <Skeleton variant="circular" width={32} height={32} />
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        ) : error ? (
          <Box p={3} textAlign="center">
            <Typography color="error">{error}</Typography>
          </Box>
        ) : (
          renderPersonCallTable()
        )}
      </Box>
      ) : (
        <Paper elevation={2} sx={{ borderRadius: 3, overflow: 'hidden' }}>
        {loading ? (
          <Paper
            elevation={1}
            sx={{
              borderRadius: 3,
              boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
              p: 0,
              overflow: 'auto',
              background: 'background.paper',
            }}
          >
            <TableContainer sx={{ maxHeight: 540 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow sx={{ bgcolor: 'primary.main' }}>
                    {Array.from(new Array(10)).map((_, colIndex) => (
                      <TableCell
                        key={colIndex}
                        sx={{
                          fontWeight: 700,
                          fontSize: '1rem',
                          background: '#0088cc',
                          color: '#fff',
                          textAlign: 'center',
                        }}
                      >
                        <Skeleton variant="text" width={80} height={24} />
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {Array.from(new Array(10)).map((_, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {Array.from(new Array(10)).map((_, colIndex) => (
                        <TableCell key={colIndex}>
                          <Skeleton variant="text" width="90%" height={20} />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box sx={{ px: 2, py: 1, background: 'background.paper', borderRadius: '0 0 16px 16px' }}>
              <Skeleton variant="rectangular" width="100%" height={40} />
            </Box>
          </Paper>
        ) : error ? (
          <Box p={3} textAlign="center">
            <Typography color="error">{error}</Typography>
          </Box>
        ) : (
          renderPersonCallTable()
        )}
      </Paper> 
    )}


      {/* Person Call History Modal for the mobile view   */}
      {isSmallScreen ? (
      <Dialog 
        open={showPersonModal} 
        onClose={handleClosePersonModal} 
        maxWidth="lg" 
        fullWidth
         PaperProps={{ sx: isSmallScreen ? { width: '90%', height: '90vh', margin: 'auto', borderRadius: 3,} : {width:'100%'} }} >
        <DialogTitle>
          <Box display="flex" alignItems="center" gap={2}>
            <Avatar sx={{ bgcolor: 'primary.main' }}>
              <PersonIcon />
            </Avatar>
            <Box>
              <Typography variant="h6" fontWeight={600} sx={{ color: 'warning.main' }}>
                {selectedPerson?.patient || 'Unknown'}
              </Typography>
              <Typography variant="body2" sx={{ color: 'background.text' }}>
                {selectedPerson?.phone}
              </Typography>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {selectedPerson && (
            <Box>

              <Box>
                {/* <Tooltip title="Click to view total number of calls"> */}
                  <Card 
                    sx={{ 
                        minWidth: 120,  textAlign: 'center', cursor: 'pointer', borderRadius:3,marginBottom:1,
                      boxShadow: filteredCallType === 'all' ? 3 : 1,
                      transition: 'all 0.2s ease-in-out',
                      '&:hover': {
                        boxShadow: 4,
                        transform: 'translateY(-2px)',
                        backgroundColor:'#e3f2fd',
                        '.total-calls': {
                          color: '#000',
                        }
                      }
                    }}
                    onClick={() => handleCallTypeFilter('all')}
                  >
                    <CardContent>
                      <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Typography variant="body2" color="background.text" align="left" className='total-calls' sx={{ fontSize: 15 }}>
                          Total Calls
                        </Typography>
                        <Typography variant="h5" color="warning.main" fontWeight={700} sx={{ fontSize: 15 }}  >
                          {selectedPerson.totalCalls}
                        </Typography>
                        <CallIcon color="warning"  sx={{ fontSize: 15 }}/>
                      </Box>
                    </CardContent>
                  </Card>
                {/* </Tooltip> */}

                {/* <Tooltip title="Click to view total number of recieved calls"> */}
                  <Card 
                    sx={{ 
                      flex: 1,  minWidth: 120,  textAlign: 'center', cursor: 'pointer', borderRadius:3,marginBottom:1,
                      border: filteredCallType === 'received' ? '2px solid' : '1px solid',
                      borderColor: filteredCallType === 'received' ? 'success.main' : 'divider',
                      boxShadow: filteredCallType === 'received' ? 3 : 1,
                      transition: 'all 0.2s ease-in-out',
                      '&:hover': {
                        boxShadow: 4,
                        transform: 'translateY(-2px)',
                        backgroundColor:'#e8f5e9',
                        '.recieved-calls': {
                          color: '#000',
                        }
                        // backgroundColor:theme.palette.success.light
                      }
                    }}
                    onClick={() => handleCallTypeFilter('received')}
                  >
                    <CardContent>
                      <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Typography variant="body2" color="background.text" align='left' className='recieved-calls' sx={{ fontSize: 15 }}>
                          Received Calls
                        </Typography>
                        <Typography variant="h5" color="success.main" fontWeight={700} align='left' sx={{ fontSize: 15 }} >
                          {selectedPerson.receivedCalls.length}
                        </Typography>
                        <CallReceivedIcon color="success" sx={{ fontSize: 15 }} />
                      </Box>
                    </CardContent>
                  </Card>
                {/* </Tooltip> */}

                {/* <Tooltip title="Click to view total number of dialed calls"> */}
                  <Card 
                    sx={{ 
                      flex: 1,  minWidth: 120,  textAlign: 'center', cursor: 'pointer', borderRadius:3,marginBottom:1,
                      border: filteredCallType === 'dialed' ? '2px solid' : '1px solid', borderColor: filteredCallType === 'dialed' ? 'primary.main' : 'divider', 
                      boxShadow: filteredCallType === 'dialed' ? 3 : 1,
                      transition: 'all 0.2s ease-in-out',
                      '&:hover': {
                        boxShadow: 4,
                        transform: 'translateY(-2px)',
                        backgroundColor:'#fff3e0',
                        '.dialed-calls': {
                          color: '#000',
                        }
                      }
                    }}
                    onClick={() => handleCallTypeFilter('dialed')}
                  >
                    <CardContent>
                      <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Typography variant="body2" color="background.text" align='left' className='dialed-calls' sx={{ fontSize: 15 }}>
                          Dialed Calls
                        </Typography>
                        <Typography variant="h5" color="primary.main" fontWeight={700} align='left' sx={{ fontSize: 15 }} >
                          {selectedPerson.dialedCalls.length}
                        </Typography>
                        <CallMadeIcon color="primary" sx={{ fontSize: 15 }} />
                      </Box>
                    </CardContent>
                  </Card>
                {/* </Tooltip> */}

                {/* <Tooltip title="Click to view total number of missed calls"> */}
                  <Card 
                    sx={{ 
                      flex: 1,  minWidth: 120,  textAlign: 'center', cursor: 'pointer', borderRadius:3,marginBottom:1,
                      border: filteredCallType === 'missed' ? '2px solid' : '1px solid',
                      borderColor: filteredCallType === 'missed' ? 'error.main' : 'divider',
                      boxShadow: filteredCallType === 'missed' ? 3 : 1,
                      transition: 'all 0.2s ease-in-out',
                      '&:hover': {
                        boxShadow: 4,
                        transform: 'translateY(-2px)',
                        backgroundColor:'#ffebee',
                        '.missed-calls': {
                          color: '#000',
                        }
                      }
                    }}
                    onClick={() => handleCallTypeFilter('missed')}
                  >
                    <CardContent>
                      <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Typography variant="body2" color="background.text" align='left' className='missed-calls' sx={{ fontSize: 15 }}>
                          Missed Calls
                        </Typography>
                        <Typography variant="h5" color="error.main" fontWeight={700} align='left' sx={{ fontSize: 15 }} >
                          {selectedPerson.missedCalls.length}
                        </Typography>
                        <CallMissedIcon color="error" sx={{ fontSize: 15 }} />
                      </Box>
                    </CardContent>
                  </Card>
                {/* </Tooltip> */}
              </Box>

              {/* Single table for all calls */}
              <Box>
                <Typography variant="h6" sx={{ mb: 1, color: 'background.text' }}>
                  {filteredCallType === 'all' ? 'All Calls' : 
                   filteredCallType === 'received' ? 'Received Calls' :
                   filteredCallType === 'dialed' ? 'Dialed Calls' : 'Missed Calls'} 
                  ({getFilteredCallsForPerson().length})
                </Typography>
                {renderCallDetailsTable(getFilteredCallsForPerson())}
              </Box>
            </Box>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClosePersonModal} color="inherit" sx={{ color: 'background.text' }}>
                Close
              </Button>
            </DialogActions>
      </Dialog>
      ):(
        <Dialog 
            open={showPersonModal} 
            onClose={handleClosePersonModal} 
            maxWidth="lg" 
            fullWidth
            PaperProps={{ sx: isSmallScreen ? { width: '90%', height: '90vh', margin: 'auto', borderRadius: 3,} : {width:'100%'} }} >
            <DialogTitle>
              <Box display="flex" alignItems="center" gap={2}>
                <Avatar sx={{ bgcolor: 'primary.main' }}>
                  <PersonIcon />
                </Avatar>
                <Box>
                  <Typography variant="h6" fontWeight={600} sx={{ color: 'warning.main' }}>
                    {selectedPerson?.patient || 'Unknown'}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'background.text' }}>
                    {selectedPerson?.phone}
                  </Typography>
                </Box>
              </Box>
            </DialogTitle>
            <DialogContent dividers>
              {selectedPerson && (
                <Box>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 3 }}>
                    {/* <Tooltip title="Click to view total number of calls"> */}
                      <Card 
                        sx={{ 
                          flex: 1,  minWidth: 120,  textAlign: 'center', cursor: 'pointer', borderRadius:3,
                          boxShadow: filteredCallType === 'all' ? 3 : 1,
                          transition: 'all 0.2s ease-in-out',
                          '&:hover': {
                            boxShadow: 4,
                            transform: 'translateY(-2px)',
                            backgroundColor:'#ed6c02',
                            '.total-calls': {
                              color: '#fff',
                            },
                            '.total-calls-icon': {
                              color: '#fff',
                            },
                            '.total-calls-count': {
                              color: '#fff',
                            }
                          }
                        }}
                        onClick={() => handleCallTypeFilter('all')}
                      >
                        <CardContent>
                          <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Typography variant="subtitle1" fontWeight={700} color="#ed6c02" align="left" className='total-calls'>
                              Total Calls
                            </Typography>
                            <CallIcon color="warning" className='total-calls-icon' />
                          </Box>
                          <Typography variant="h4" color="warning.main" fontWeight={700} align="left" marginTop={0.1} className='total-calls-count'>
                            {selectedPerson.totalCalls}
                          </Typography>
                        </CardContent>
                      </Card>
                    {/* </Tooltip> */}

                    {/* <Tooltip title="Click to view total number of recieved calls"> */}
                      <Card 
                        sx={{ 
                          flex: 1,  minWidth: 120,  textAlign: 'center', cursor: 'pointer', borderRadius:3,
                          border: filteredCallType === 'received' ? '2px solid' : '1px solid',
                          borderColor: filteredCallType === 'received' ? 'success.main' : 'divider',
                          boxShadow: filteredCallType === 'received' ? 3 : 1,
                          transition: 'all 0.2s ease-in-out',
                          '&:hover': {
                            boxShadow: 4,
                            transform: 'translateY(-2px)',
                            backgroundColor:'#2e7d32',
                            '.recieved-calls': {
                              color: '#fff',
                            },
                            '.recieved-calls-icon': {
                              color: '#fff',
                            },
                            '.recieved-calls-count': {
                              color: '#fff',
                            }
                            // backgroundColor:theme.palette.success.light
                          }
                        }}
                        onClick={() => handleCallTypeFilter('received')}
                      >
                        <CardContent>
                          <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Typography variant="subtitle1" fontWeight={700} color="#2e7d32" align='left' className='recieved-calls'>
                              Received Calls
                            </Typography>
                            <CallReceivedIcon color="success" className='recieved-calls-icon'/>
                          </Box>
                          <Typography variant="h4" color="success.main" fontWeight={700} align='left' marginTop={0.1} className='recieved-calls-count'>
                            {selectedPerson.receivedCalls.length}
                          </Typography>
                        </CardContent>
                      </Card>
                    {/* </Tooltip> */}

                    {/* <Tooltip title="Click to view total number of dialed calls"> */}
                      <Card 
                        sx={{ 
                          flex: 1,  minWidth: 120,  textAlign: 'center', cursor: 'pointer', borderRadius:3, 
                          border: filteredCallType === 'dialed' ? '2px solid' : '1px solid', borderColor: filteredCallType === 'dialed' ? 'primary.main' : 'divider', 
                          boxShadow: filteredCallType === 'dialed' ? 3 : 1,
                          transition: 'all 0.2s ease-in-out',
                          '&:hover': {
                            boxShadow: 4,
                            transform: 'translateY(-2px)',
                            backgroundColor:'#0088cc',
                            '.dialed-calls': {
                              color: '#fff',
                            },
                            '.dialed-calls-icon': {
                              color: '#fff',
                            },
                            '.dialed-calls-count': {
                              color: '#fff',
                            }
                          }
                        }}
                        onClick={() => handleCallTypeFilter('dialed')}
                      >
                        <CardContent>
                          <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Typography variant="subtitle1" fontWeight={700} color="#0088cc" align='left' className='dialed-calls'>
                              Dialed Calls
                            </Typography>
                            <CallMadeIcon color="primary" className='dialed-calls-icon' />
                          </Box>
                          <Typography variant="h4" color="primary.main" fontWeight={700} align='left' marginTop={0.1} className='dialed-calls-count'>
                            {selectedPerson.dialedCalls.length}
                          </Typography>
                        </CardContent>
                      </Card>
                    {/* </Tooltip> */}

                    {/* <Tooltip title="Click to view total number of missed calls"> */}
                      <Card 
                        sx={{ 
                          flex: 1,  minWidth: 120,  textAlign: 'center', cursor: 'pointer', borderRadius:3,
                          border: filteredCallType === 'missed' ? '2px solid' : '1px solid',
                          borderColor: filteredCallType === 'missed' ? 'error.main' : 'divider',
                          boxShadow: filteredCallType === 'missed' ? 3 : 1,
                          transition: 'all 0.2s ease-in-out',
                          '&:hover': {
                            boxShadow: 4,
                            transform: 'translateY(-2px)',
                            backgroundColor:'#d32f2f',
                            '.missed-calls': {
                              color: '#fff',
                            },
                            '.missed-calls-icon': {
                              color: '#fff',
                            },
                            '.missed-calls-count': {
                              color: '#fff',
                            }
                          }
                        }}
                        onClick={() => handleCallTypeFilter('missed')}
                      >
                        <CardContent>
                          <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Typography variant="subtitle1" fontWeight={700} color="#d32f2f" align='left' className='missed-calls'>
                              Missed Calls
                            </Typography>
                            <CallMissedIcon color="error" className='missed-calls-icon' />
                          </Box>
                          <Typography variant="h4" color="error.main" fontWeight={700} align='left' marginTop={0.1} className='missed-calls-count'>
                            {selectedPerson.missedCalls.length}
                          </Typography>
                        </CardContent>
                      </Card>
                    {/* </Tooltip> */}
                  </Box>

                  {/* Single table for all calls */}
                  <Box>
                    <Typography variant="h6" sx={{ mb: 1, color: 'background.text' }}>
                      {filteredCallType === 'all' ? 'All Calls' : 
                      filteredCallType === 'received' ? 'Received Calls' :
                      filteredCallType === 'dialed' ? 'Dialed Calls' : 'Missed Calls'} 
                      ({getFilteredCallsForPerson().length})
                    </Typography>
                    {renderCallDetailsTable(getFilteredCallsForPerson())}
                  </Box>
                </Box>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClosePersonModal} color="inherit" sx={{ color: 'background.text' }}>
                Close
              </Button>
            </DialogActions>
          </Dialog>
          )}

      <Card elevation={2}
        sx={{
          display: isSmallScreen ? 'none' : 'flex', gap: 1.5, flexWrap: 'wrap', alignItems: 'center', borderRadius: 2, padding: 2, maxWidth: 'fit-content', mt:3,
          backgroundColor: theme.palette.mode === 'dark' ? '#424242' : '#f9f9f9', boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)'
        }}
      >
        <Chip label='Received' size="medium" color="success" variant="outlined" 
          sx={{ backgroundColor: '#d0f0c0',color: '#2e7d32', borderColor: '#2e7d32' }}  
        />
        <Chip label='Missed' size="medium" color="error" variant="outlined" 
          sx={{ backgroundColor: '#f0c0c0',color: '#c62828', borderColor: '#c62828' }} 
        />
        <Chip label='Dialed' size="medium" color="primary" variant="outlined" 
          sx={{ backgroundColor: '#c0d8f0',color: '#1565c0', borderColor: '#1565c0' }}
        />
        <Chip label='Connected' size="medium"
          sx={{color: 'common.white',textTransform: 'capitalize',fontWeight: 500,fontSize: '0.75rem',bgcolor: 'success.main'}}
        />
        <Chip label='Not Connected' size="medium"
          sx={{color: 'common.white',textTransform: 'capitalize',fontWeight: 500,fontSize: '0.75rem',bgcolor: 'error.dark'}}
        />
      </Card>

      {/* WhatsApp Confirmation Dialog */}
      <Dialog open={showWhatsAppDialog} onClose={handleCancelWhatsApp} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box display="flex" alignItems="center" gap={2}>
            <WhatsAppIcon sx={{ color: '#25D366', fontSize: 28 }} />
            <Typography variant="h6" fontWeight={600} sx={{ color: 'background.text' }}>
              Send WhatsApp Message
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedCall && (
            <Box>
              <Typography variant="body1" sx={{ mb: 2, color: 'background.text' }}>
                Are you sure you want to send a WhatsApp message to:
              </Typography>
              <Box sx={{ bgcolor: 'background.paper', p: 2, borderRadius: 2, mb: 2 }}>
                <Typography variant="subtitle1" fontWeight={600} color="primary">
                  {selectedCall.patient}
                </Typography>
                <Typography variant="body2" color="background.text">
                  {selectedCall.phone}
                </Typography>
                <Typography variant="body2" color="background.text">
                  Device ID: {selectedCall.service}
                </Typography>
              </Box>
              <Typography variant="body2" color="background.text">
                A default message will be sent asking them to contact us for their {selectedCall.service.toLowerCase()} request.
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelWhatsApp} color="inherit" sx={{ color: 'background.text' }}>
            Cancel
          </Button>
          <Button
            onClick={handleSendWhatsApp}
            variant="contained"
            sx={{
              bgcolor: '#25D366',
              '&:hover': { bgcolor: '#1ebe57' },
            }}
            startIcon={<WhatsAppIcon />}
          >
            Send WhatsApp
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} >

        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} elevation={6} variant="filled" sx={{ fontSize: 16, fontWeight: 600, borderRadius: 2 }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default CallLogsPageCopy;